import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { State } from 'src/app/app.reducer';
import * as fromReducer from '../../voluntary-change/reducers/voluntary-change.reducer';
import * as fromInvoluntaryReducer from '../../involuntary-change/reducers/involuntary-change.reducer';
import { ExceptionActions } from '../actions';
import {
  FixedChargeOverride,
  IEditValuesModal,
  PenaltyOverride
} from 'src/app/core/models/cancellation-overrides.model';
import {
  ExchangeOverrideState,
  ExchangeFareOverrideRequest
} from 'src/app/core/models/exchange-override.model';

@Injectable({ providedIn: 'root' })
export class ExchangeOverrideService {
  constructor(private store: Store<State>) {}

  getExchangeOverrideState(): Observable<ExchangeOverrideState> {
    return this.store.pipe(select(fromReducer.selectExchangeOverrideState));
  }

  getExchangeOverrideStateNewFlow(): Observable<ExchangeOverrideState> {
    return this.store.pipe(select(fromInvoluntaryReducer.selectExchangeOverrideState));
  }

  getExchangeOverrideRequest(): Observable<ExchangeFareOverrideRequest> {
    return this.store.pipe(select(fromReducer.selectExchangeFareOverrideRequest));
  }

  getExchangeOverrideNewFlowRequest(): Observable<ExchangeFareOverrideRequest> {
    return this.store.pipe(select(fromInvoluntaryReducer.selectExchangeFareOverrideRequest));
  }

  saveFixedCharges(fixedChargeOverrides: FixedChargeOverride[]) {
    this.store.dispatch(ExceptionActions.SaveFixedCharges({ fixedChargeOverrides }));
  }

  savePenalties(valuesModal: IEditValuesModal) {
    this.store.dispatch(ExceptionActions.SavePenalties({ valuesModal }));
  }

  changeCostMode(isNoDifferenceValue: boolean) {
    this.store.dispatch(ExceptionActions.ChangeCostMode({ isNoDifferenceValue }));
  }

  saveFixedChargesNewFlow(fixedChargeOverrides: FixedChargeOverride[]) {
    this.store.dispatch(ExceptionActions.SaveFixedChargesNewFlow({ fixedChargeOverrides }));
  }

  savePenaltiesNewFlow(penalties: PenaltyOverride[]) {
    this.store.dispatch(ExceptionActions.SavePenaltiesNewFlow({ penalties }));
  }

  changeCostModeNewFlow(isNoDifferenceValue: boolean) {
    this.store.dispatch(ExceptionActions.ChangeCostModeNewFlow({ isNoDifferenceValue }));
  }
}
